// extracted by mini-css-extract-plugin
module.exports = {"pagination":"Pagination_pagination__2guDI","active":"Pagination_active__1zUBA","disabled":"Pagination_disabled__lMNRm"};